export const useImageTransform = () => {
   const imageToImageEditing = async (prompt: {
      style: string;
      substyle: string;
      prompt: string;
      strength: number;
      url: string;
      num_images?: number;
      template_type?: string;
   }) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/transform-image`, {
            method: 'POST',
            body: JSON.stringify(prompt),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         if (!res.ok) {
            const errorBody = await res.json().catch(() => ({}));
            throw new Error(errorBody.message || `Transform failed (${res.status})`);
         }
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const replaceBackground = async (prompt: {
      style: string;
      substyle: string;
      prompt: string;
      url: string;
      num_images?: number;
   }) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/replace-background`, {
            method: 'POST',
            body: JSON.stringify(prompt),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         if (!res.ok) {
            const errorBody = await res.json().catch(() => ({}));
            throw new Error(errorBody.message || `Replace background failed (${res.status})`);
         }
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const removeBackground = async (url: string) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/remove-background`, {
            method: 'POST',
            body: JSON.stringify({ url }),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         if (!res.ok) {
            const errorBody = await res.json().catch(() => ({}));
            throw new Error(errorBody.message || `Remove background failed (${res.status})`);
         }
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const generateImage = async (params: {
      prompt: string;
      style: string;
      substyle: string;
      num_images?: number;
   }) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/generate-image`, {
            method: 'POST',
            body: JSON.stringify(params),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         if (!res.ok) {
            const errorBody = await res.json().catch(() => ({}));
            throw new Error(errorBody.message || `Generate image failed (${res.status})`);
         }
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const crispUpscale = async (url: string) => {
      try {
         const res = await fetch(`${process.env.REACT_APP_API_URL}/api/crisp-image`, {
            method: 'POST',
            body: JSON.stringify({ url }),
            headers: {
               'Content-Type': 'application/json',
            },
         });
         if (!res.ok) {
            const errorBody = await res.json().catch(() => ({}));
            throw new Error(errorBody.message || `Crisp upscale failed (${res.status})`);
         }
         return res.json();
      } catch (err: any) {
         throw err;
      }
   };

   const enhanceImage = async ({ url, preset, settings }: {
      url: string;
      preset: string;
      settings: {
         brightness: number;
         contrast: number;
         sharpness: number;
         saturation: number;
         warmth: number;
         shadows: number;
         skinSmoothing: number;
      };
   }) => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/enhance-image`, {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ url, preset, settings }),
      });
      if (!res.ok) {
         const err = await res.json().catch(() => ({}));
         throw new Error(err.error || `Enhancement failed (${res.status})`);
      }
      return res.json();
   };

   const analyzeImage = async ({ url, sourceType }: {
      url: string;
      sourceType: string;
   }) => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/analyze-image`, {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ url, source_type: sourceType }),
      });
      if (!res.ok) {
         const err = await res.json().catch(() => ({}));
         throw new Error(err.error || `Analysis failed (${res.status})`);
      }
      return res.json();
   };

   return {
      generateImage,
      imageToImageEditing,
      enhanceImage,
      analyzeImage,
      replaceBackground,
      removeBackground,
      crispUpscale,
   };
};

export default useImageTransform;
